import React from 'react';
import { Bookmark, BookmarkActionHandlers } from '../shared/types';
import { groupBookmarksByDate } from '../shared/utils';
import { DateGroupHeader } from '../shared/DateGroupHeader';
import { BookmarkCard } from '../shared/BookmarkCard';

interface GroupedCardLayoutProps {
  bookmarks: Bookmark[];
  handlers: BookmarkActionHandlers;
}

export const GroupedCardLayout: React.FC<GroupedCardLayoutProps> = ({ bookmarks, handlers }) => {
  const bookmarkGroups = groupBookmarksByDate(bookmarks);

  return (
    <>
      {bookmarkGroups.map(group => (
        <div key={group.dateKey} className="bookmark-date-group">
          <DateGroupHeader group={group} />
          <div className="bookmarks-grid grouped">
            {group.bookmarks.map(bookmark => (
              <BookmarkCard
                key={bookmark.id}
                bookmark={bookmark}
                handlers={handlers}
                isGrouped={true}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};